<template>
  <div class="pageContainer">
    <BannerComponent>
      <h6 class="banner-heading">Configured Firewall Rules</h6>
    </BannerComponent>
    <button class="primaryButton" @click="openAdd">Add Rule</button>
    <div class="search-bar" style="margin-top: 1rem;">
      <div class="search-input-wrapper">
        <font-awesome-icon :icon="['fas','magnifying-glass']" class="search-icon"/>
        <input
            type="text"
            v-model="searchTerm"
            placeholder="Search Rules..."
            class="search-input cardBackground"
            @input="filterRules"
        />
      </div>
      <button class="filter-btn" @click="filterRules">
        <font-awesome-icon :icon="['fas','filter']" />
      </button>
    </div>
    <div class="card cardBackground">
      <div class="cardContentWrapper" v-for="rule of pagedDevices" v-bind:key="rule.id">
        <div class="cardLine">
          <p>
            {{rule.name}}
          </p>
          <p>
            {{rule.type}}
          </p>
          <p v-if="rule.type === 'Port-Based'">
            {{rule.port}}
          </p>
          <p v-if="rule.type === 'IP-Based'">
            {{rule.ip}}
          </p>
          <font-awesome-icon @click="openInfo(rule)" class="infoIcon" :icon="['fas', 'circle-info']" />
        </div>
        <div class="lineDiv" />
      </div>
    </div>
    <div class="pagination-controls">
      <!-- "<" previous page -->
      <button
          class="page-arrow"
          :disabled="currentPage === 1"
          @click="goToPage(currentPage - 1)"
      >
        <font-awesome-icon :icon="['fas','fa-angles-left']" />
      </button>

      <!-- Individual page numbers -->
      <button
          v-for="page in visiblePages"
          :key="page"
          class="page-number"
          :class="{ 'active-page': page === currentPage }"
          @click="goToPage(page)"
      >
        {{ page }}
      </button>

      <!-- ">" next page -->
      <button
          class="page-arrow"
          :disabled="currentPage === pageCount"
          @click="goToPage(currentPage + 1)"
      >
        <font-awesome-icon :icon="['fas','fa-angles-right']" />
      </button>

    </div>
    <BaseModal
        :visible="modals.open"
        :cancel-show="false"
        @close="closeModal"
        :title="modals.title"
        :submit-label="modals.submitLabel"
        @submit="submit"
    >
      <div class="modalContainer" v-if="modals.mode === 'info'">
        <div class="modalLine">
          <div class="text-box-label" style="margin-top:.5rem;">
            Name:
          </div>
          <p style="margin-left: 15px">{{selectedRule.name}}</p>
        </div>
        <div class="modalLine" v-if="selectedRule.description">
          <div class="text-box-label" style="margin-top:.5rem;">
            Description:
          </div>
          <p style="margin-left: 15px">{{selectedRule.description}}</p>
        </div>
        <div class="modalLine">
          <div class="text-box-label" style="margin-top:.5rem;">
            Rule Type:
          </div>
          <p style="margin-left: 15px">{{selectedRule.type}}</p>
        </div>
        <div class="modalLine" v-if="selectedRule.type === 'Port-Based'">
          <div class="text-box-label" style="margin-top:.5rem;">
            Protocol:
          </div>
          <p style="margin-left: 15px">{{selectedRule.protocol}}</p>
        </div>
        <div class="modalLine" v-if="selectedRule.type === 'Port-Based'">
          <div class="text-box-label" style="margin-top:.5rem;">
            Port:
          </div>
          <p style="margin-left: 15px">{{selectedRule.port}}</p>
        </div>
        <div class="modalLine" v-if="selectedRule.type === 'IP-Based'">
          <div class="text-box-label" style="margin-top:.5rem;">
            Port:
          </div>
          <p style="margin-left: 15px">{{selectedRule.ip}}</p>
        </div>
        <div class="modalLine">
          <div class="text-box-label" style="margin-top:.5rem;">
            Rule Action:
          </div>
          <p style="margin-left: 15px">{{selectedRule.action}}</p>
        </div>
      </div>
      <div class="modalContainer" v-else>
        <div class="modalLine">
          <div class="text-box-label" style="margin-top:.5rem;">
            Name:
          </div>
          <input type="text" v-model="selectedRule.name">
        </div>
        <div class="modalLine">
          <div class="text-box-label" style="margin-top:.5rem;">
            Description:
          </div>
          <input type="text" v-model="selectedRule.description">
        </div>
        <div class="modalLine">
          <div class="text-box-label" style="margin-top:.5rem;">
            Rule Type:
          </div>
          <CustomSelect
              :options="possibleTypes"
              v-model="selectedRule.type"
              :searchable="false"
          ></CustomSelect>
        </div>
        <div class="modalLine" v-if="selectedRule.type === 'Port-Based'">
          <div class="text-box-label" style="margin-top:.5rem;">
            Protocol:
          </div>
          <CustomSelect
              v-model="selectedRule.protocol"
              :options="protocolOptions"
              :searchable="false"
          ></CustomSelect>
        </div>
        <div class="modalLine" v-if="selectedRule.type === 'Port-Based'">
          <div class="text-box-label" style="margin-top:.5rem;">
            Port:
          </div>
          <input type="text" v-model="selectedRule.port">
        </div>
        <div class="modalLine" v-if="selectedRule.type === 'IP-Based'">
          <div class="text-box-label" style="margin-top:.5rem;">
            IP:
          </div>
          <input type="text" v-model="selectedRule.ip">
        </div>
        <div class="modalLine">
          <div class="text-box-label" style="margin-top:.5rem;">
            IP:
          </div>
          <CustomSelect
              :options="possibleActions"
              v-model="selectedRule.action"
              :searchable="false"
          ></CustomSelect>
        </div>
      </div>
    </BaseModal>
    <MessageModal :message="appMessage.text" :type="appMessage.type" ref="messageModal" />
  </div>
</template>

<script>
import MessageModal from "@/components/MessageModal.vue";
import BannerComponent from "@/components/BannerComponent.vue";
import BaseModal from "@/components/BaseModal.vue";
import CustomSelect from "@/components/CustomSelect.vue";

export default {
  name: 'FirewallRulesPage',
  components: {CustomSelect, BaseModal, BannerComponent, MessageModal},
  data(){
    return {
      appMessage: {
        text: '',
        type: 'error',
      },
      searchTerm: '',
      configuredRules: [],
      filteredRules: [],
      selectedRule: {},
      modals: {
        open: false,
        title: '',
        submitLabel: '',
        mode: 'info',
      },
      possibleTypes: [
        {
          id: 'Port-Based',
          name: 'Port-Based',
        },
        {
          id: 'IP-Based',
          name: 'IP-Based',
        },
      ],
      possibleActions: [
        {
          id: 'Allow',
          name: 'Allow',
        },
        {
          id: 'Deny',
          name: 'Deny',
        }
      ],
      protocolOptions: [
        {
          id: 'TCP',
          name: 'TCP',
        },
        {
          id: 'UDP',
          name: 'UDP',
        },
      ],
      currentPage: 1,
      itemsPerPage: 6
    }
  },
  mounted(){
    this.getConfiguredRules()
  },
  computed: {
    pageCount() {
      return Math.ceil(this.filteredRules.length / this.itemsPerPage);
    },
    pagedDevices() {
      const startIndex = (this.currentPage - 1) * this.itemsPerPage;
      const endIndex = startIndex + this.itemsPerPage;
      return this.filteredRules.slice(startIndex, endIndex);
    },
    visiblePages() {
      const pages = [];
      const lower = Math.max(1, this.currentPage - 1);
      const upper = Math.min(this.pageCount, this.currentPage + 1);
      for (let p = lower; p <= upper; p++) {
        pages.push(p);
      }
      return pages;
    }
  },
  methods: {
    getConfiguredRules(){
      this.configuredRules = [
        {
          id: 1,
          name: 'Rule Name1',
          description: '',
          type: 'Port-Based',
          protocol: 'TCP',
          port: '8080',
          ip: '123.123.123.123',
          action: 'Allow'
        },
        {
          id: 2,
          name: 'Rule Name2',
          description: '',
          type: 'IP-Based',
          protocol: 'TCP',
          port: '8080',
          ip: '123.123.123.123',
          action: 'Allow'
        },
      ]

      this.filteredRules = this.configuredRules
    },
    openAdd(){
      this.selectedRule =
          {
            id: this.configuredRules.length + 1,
            name: '',
            description: '',
            type: 'Port-Based',
            protocol: '',
            port: '',
            ip: '',
            action: 'Allow'
          }
      this.modals.title = 'Add Firewall Rule'
      this.modals.submitLabel = 'Add'
      this.modals.mode = 'add'
      this.modals.open = true
    },
    openInfo(rule){
      this.selectedRule = rule
      this.modals.title = 'Firewall Rule Info'
      this.modals.submitLabel = 'Edit'
      this.modals.mode = 'info'
      this.modals.open = true
    },
    openEdit(rule){
      this.selectedRule = JSON.parse(JSON.stringify(rule))
      this.modals.title = 'Edit Firewall Rule'
      this.modals.submitLabel = 'Save'
      this.modals.mode = 'edit'
      this.modals.open = true
    },
    submit(){
      if (this.modals.mode === 'info'){
        this.openEdit(this.selectedRule)
      }
      else if (this.modals.mode === 'edit'){
        const idx = this.configuredRules.findIndex(
            data => data.id === this.selectedRule.id
        );
        if (idx !== -1) {
          this.configuredRules[idx] = this.selectedRule;
        }
        this.closeModal();
      }
      else if (this.modals.mode === 'add'){
        this.configuredRules.push(this.selectedRule)
        this.closeModal()
      }
    },
    closeModal(){
      this.selectedRule = {}
      this.modals.title = ''
      this.modals.open = false
      this.filteredRules = this.configuredRules
    },
    filterRules(){
      this.filteredRules = this.configuredRules.filter(data => data.name.toLowerCase().includes(this.searchTerm.toLowerCase()))
    },
    goToPage(page) {
      if (page < 1) page = 1;
      if (page > this.pageCount) page = this.pageCount;
      this.currentPage = page;
    },
  },
}
</script>
